// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610231105/js/" + chunkId + "." + {"44":"55ac418d","225":"9e05cbff","481":"abf02bb2","486":"b4ef0ec9","770":"ca5cd7db"}[chunkId] + ".0.6571316260587305.chunk.js";
};